import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/DasboardView.vue'
import LoginComponent from '../views/LoginView.vue'
import ClientsView from '@/views/ClientsView.vue'
import ProspectosView from '@/views/ProspectosView.vue'
import VistaOrganizacionComponent from '@/components/organizacion/VistaOrganizacionComponent.vue'

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/',
    name: 'Logins',
    component: LoginComponent
  },
  {
    path:'/clientes',
    name: 'clientes',
    component: ClientsView
  },
  {
    path:'/prospectos',
    name: 'prospectos',
    component: ProspectosView
  },
  {
    path: '/organizacion/:id',
    name: 'organizacionvista',
    component: VistaOrganizacionComponent
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
